import "core-js/modules/es6.regexp.replace";
import _typeof from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";

function removeHttp(src) {
  if (!src) return src;

  if (_typeof(src) === 'object' && src.backgroundImage) {
    src.backgroundImage = src.backgroundImage.replace(/^http:/, '');
    return src;
  }

  if (typeof src === 'string') {
    return src.replace(/^http:/, '');
  }

  return src;
}

export default {
  install: function install(Vue) {
    function bind(el, binding) {
      var imgUrl = removeHttp(binding.value);

      if (el.tagName.toLowerCase() === 'img') {
        $(el).attr('src', imgUrl);
      } else {
        $(el).css('background-image', 'url(' + imgUrl + ')');
      }
    }

    Vue.directive('img', {
      bind: bind
    });
  }
};